import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { AbTestsView } from '../features/list-ab-tests/AbTestsView';

export const Router: React.FC = () => {
  const basename = '/optimize/ab-tests';

  return (
    <>
      <BrowserRouter basename={basename}>
        <Route path="/" exact component={AbTestsView} />
      </BrowserRouter>
    </>
  );
};
